var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',_vm._l((_vm.childColumns),function(column){return _c('td',{key:column.label,domProps:{"innerHTML":_vm._s(column.formatMethod
      ? column.formatMethod(_vm.childRowData[column.prop])
      : _vm.childRowData[column.prop]
    )}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }